"use client";
import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import Markdown from "@/components/atoms/Markdown";


import styles from "./WhyAmity.module.scss";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";


const SVG_DATA = [
  {
    heading: "WASC Accreditation (USA)",
    subHeading:
      "Amity Online is India's only university accredited by the Western Association of Schools and Colleges  — a distinguished recognition of global academic excellence.",
      src:`https://amityonline.com/_s/WASC_new_logo_1_d7a81ca9c3.webp`,
    type:"PNG",
    style:'!w-[6rem]' 
  },
  {
    heading: "WES Recognition",
    subHeading:
      "Degrees recognized by World Education Services (WES) Canada & USA, enabling smoother pathways for higher studies and global career mobility.",
      src:"https://amityonline.com/_s/Group_48099252_1_df96398b17_8a67bc8d63_b0fc08c271.webp",
    type:"PNG" 
  },
  {
    heading: "QS Ranked Online MBA",
    subHeading:
      "Amity Online offers India's only Online MBA ranked by QS under Asia Pacific Top 10 - a global recognition for academic strength, learner outcomes, and digital innovation.",
      src:'https://amityonline.com/_s/Group_48099254_1_46922cfc87_920634f33f.webp',
    type:"PNG" 
  },
  {
    heading: "QAA (UK) Accreditation",
    subHeading:"Accredited by the UK's Quality Assurance Agency (QAA), assuring students of globally benchmarked academic quality.",
    src:"https://amityonline.com/_s/qaa_44482cac1e.webp",
    type:"PNG" ,
    style:'!w-[6rem]'
  },
  {
    heading: "Times Higher Education Employability Rankings",
    subHeading:
      "Amity University is ranked among the best globally for graduate employability and employer reputation by Times Higher Education.",
      src:'https://amityonline.com/_s/Times_Higher_Education_logo_1_1_f1dd81080b.webp',
    type:"PNG" ,
    style:'!w-[7rem]'
  },
  {
    heading: "Pan-India Campus Access & Offline Events",
    subHeading:
      "Enjoy access to all Amity campuses for events like orientation, mid-year meetups, on-campus connect and convocation - blending digital convenience with real-world connection.",
    src: IMAGE_ASSETS.offlineExperiences,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Amigo: Learning On-the-Go",
    subHeading:
      "The Amigo app makes learning seamless and mobile — attend live classes, track progress, access materials, and more on your schedule.",
    src: IMAGE_ASSETS.lmsIcon,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Prof. Ami: Your AI-Powered Personal Tutor",
    subHeading:
      "Meet Prof. Ami — your always-on, AI mentor for instant doubt-solving, personalised learning tips, and smart academic support.",
    src: IMAGE_ASSETS.aiProfessor,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Industry Certifications for Better Employability",
    subHeading:
      "Gain an edge with in-demand certifications from top industry bodies and partners — integrated within your program to boost your skills and CV.",
    src: IMAGE_ASSETS.diverseLearningMediums,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Internship Opportunities",
    subHeading:
      "Access curated internships with leading companies through our corporate network, helping you gain real-world experience and stand out in the job market.",
    src: IMAGE_ASSETS.placementOpportunities,
    type: "IMG",
    width: 52,
    height: 45 
  },
  {
    heading: "AI-Powered Career Discovery Platform",
    subHeading:
      "From mock interviews and resume building to job search and easy-apply tools — our AI-powered platform ensures you’re career-ready from day one.",
    src: IMAGE_ASSETS.careerServices,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "beSocial App for Campus Life",
    subHeading:
      "Your virtual student hub — the beSocial app lets you network, join clubs, attend events, and be part of a vibrant, online-first community.",
      src:'https://amityonline.com/_s/besocial_1_1db313ae01.webp',
    type:"PNG" 
  },
];
const CitySVG_DATA =[
  {
    heading: "WASC Accreditation (USA)",
    subHeading:
      "Amity Online is India's only university accredited by the Western Association of Schools and Colleges  — a distinguished recognition of global academic excellence.",
      src:`https://amityonline.com/_s/WASC_new_logo_1_d7a81ca9c3.webp`,
    type:"PNG",
    style:'!w-[6rem]' 
  },
  {
    heading: "WES Recognition",
    subHeading:
      "Degrees recognized by World Education Services (WES) Canada & USA, enabling smoother pathways for higher studies and global career mobility.",
      src:"https://amityonline.com/_s/Group_48099252_1_df96398b17_8a67bc8d63_b0fc08c271.webp",
    type:"PNG" 
  },
  {
    heading: "QS Ranked Online MBA",
    subHeading:
      "Amity Online offers India's only Online MBA ranked by QS under Asia Pacific Top 10 2024 - a global recognition for academic strength, learner outcomes, and digital innovation.",
      src:'https://amityonline.com/_s/Group_48099254_1_46922cfc87_920634f33f.webp',
    type:"PNG" 
  },
  {
    heading: "QAA (UK) Accreditation",
    subHeading:"Accredited by the UK's Quality Assurance Agency (QAA), assuring students of globally benchmarked academic quality.",
    src:"https://amityonline.com/_s/qaa_44482cac1e.webp",
    type:"PNG" ,
    style:'!w-[6rem]'
  },
  {
    heading: "Times Higher Education Employability Rankings",
    subHeading:
      "Amity University is ranked among the best globally for graduate employability and employer reputation by Times Higher Education.",
      src:'https://amityonline.com/_s/Times_Higher_Education_logo_1_1_f1dd81080b.webp',
    type:"PNG" ,
    style:'!w-[7rem]'
  },
  {
    heading: "Pan-India Campus Access & Offline Events",
    subHeading:
      "Enjoy access to all Amity campuses for events like orientation, mid-year meetups, on-campus connect and convocation - blending digital convenience with real-world connection.",
    src: IMAGE_ASSETS.offlineExperiences,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Amigo: Learning On-the-Go",
    subHeading:
      "The Amigo app makes learning seamless and mobile — attend live classes, track progress, access materials, and more on your schedule.",
    src: IMAGE_ASSETS.lmsIcon,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Prof. Ami: Your AI-Powered Personal Tutor",
    subHeading:
      "Meet Prof. Ami — your always-on, AI mentor for instant doubt-solving, personalised learning tips, and smart academic support.",
    src: IMAGE_ASSETS.aiProfessor,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Industry Certifications for Better Employability",
    subHeading:
      "Gain an edge with in-demand certifications from top industry bodies and partners — integrated within your program to boost your skills and CV.",
    src: IMAGE_ASSETS.diverseLearningMediums,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "Internship Opportunities",
    subHeading:
      "Access curated internships with leading companies through our corporate network, helping you gain real-world experience and stand out in the job market.",
    src: IMAGE_ASSETS.placementOpportunities,
    type: "IMG",
    width: 52,
    height: 45 
  },
  {
    heading: "AI-Powered Career Discovery Platform",
    subHeading:
      "From mock interviews and resume building to job search and easy-apply tools — our AI-powered platform ensures you’re career-ready from day one.",
    src: IMAGE_ASSETS.careerServices,
    type: "IMG",
    width: 52,
    height: 52 
  },
  {
    heading: "beSocial App for Campus Life",
    subHeading:
      "Your virtual student hub — the beSocial app lets you network, join clubs, attend events, and be part of a vibrant, online-first community.",
      src:'https://amityonline.com/_s/besocial_1_1db313ae01.webp',
    type:"PNG" 
  },
];

const IntersectionObserverWrapper = ({ children }) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) =>
      entry.isIntersecting ? setIntersecting(entry.isIntersecting) : null
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={styles.intersectionDiv} ref={ref}>
      {isIntersecting ? children : null}
    </div>
  );
};
const AFRICA_SVG =[
  {
    heading: "NCHE",
    subHeading:"First Indian University to be accredited by National Council for Higher Education, Africa",
    src:'https://amityonline.com/_s/NCHE_Malawi_Logo1_377ed6cbbe_1_2ad697d3d1.webp',
    type:"PNG" ,
  },
  {
    heading: "ZAQA",
    subHeading:"The Zambia Qualifications Authority (ZAQA) is the national body responsible for regulating and assuring the quality of qualifications in Zambia.",
    src:'https://amityonline.com/_s/ZQA_Logo_136x136_copy_cbb258d0e0.webp',
    type:"PNG" ,
    style:'!w-[7rem]'
  },
  {
    heading: "SAQA",
    subHeading:"The South African Qualifications Authority (SAQA) is the statutory body that oversees the development and implementation of the National Qualifications Framework (NQF).",
    src:'https://amityonline.com/_s/SAQA_Logo_136x136_copy_de1c9c6a3d.webp',
    type:"PNG" ,
    style:'!w-[5rem]'
  },
]
export default function WhyAmityItemClientWrapper({isAfricaPage=false,IsCityPage=false}) {
  const tempSVG_DATA = IsCityPage?[...CitySVG_DATA]:[...SVG_DATA];
  if (isAfricaPage) {
    tempSVG_DATA.splice(5, 0, ...AFRICA_SVG);
  }
  return (
    <>
      {tempSVG_DATA.map(({ heading, subHeading, type, src, style, width, height }, index) => {
        return (
          <React.Fragment key={heading}>
            <div id={`whyamitycard-${index}`} className={clsx("font-raleway", styles.item, styles.centerdItem)}>
              <div className={styles.wrapperIntersection}>
                <IntersectionObserverWrapper>
                  <UnivoImage
                    className={style}
                    src={src}
                    alt={heading}
                    width={width || 84}
                    height={height || 42}
                    sizes={`${width || 84}px`}
                  />
                </IntersectionObserverWrapper>
              </div>

              <Markdown as="h3" className={styles.title}>
                {heading}
              </Markdown>

              <p className={clsx("text-sec", styles.subtitle)}>{subHeading}</p>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
}
